import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { changeCoreLanguage } from '../../../state/actions/core.actions';

import { selectFooterView } from './footer.component.selectors';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false,
})
export class FooterComponent {
    private store = inject(Store);

    view$ = this.store.select(selectFooterView);

    changeLanguage(language: 'de' | 'fr' | 'it') {
        this.store.dispatch(changeCoreLanguage({ language }));
    }
}
